module.exports = __webpack_public_path__ + "static/media/logo_lockup_firebase_horizontal.bb7bb32c.svg";